import { usePermissionContext } from '../contexts/PermissionContext';
import { Capability, FeatureKey } from '../rbac/features';

interface UsePermissionResult {
  // Does the caller have at least `level` on this feature? Admin short-circuits to true;
  // edit implies view.
  can: (level: 'view' | 'edit') => boolean;
  // The raw capability on this feature ("none" | "view" | "edit").
  cap: Capability;
}

// Frontend analogue of the backend requirePermission. Reads from PermissionContext. Admin
// short-circuits every check to true (replaces the old super-admin blanket bypass). Purely
// a UX helper — the backend independently enforces every read/mutation (SI-1/SI-5).
export function usePermission(featureKey: FeatureKey): UsePermissionResult {
  const { permissions, isAdmin } = usePermissionContext();
  const cap: Capability = (permissions[featureKey] as Capability) || 'none';

  const can = (level: 'view' | 'edit'): boolean => {
    if (isAdmin) return true;
    if (level === 'view') return cap === 'view' || cap === 'edit';
    return cap === 'edit';
  };

  return { can, cap };
}

export type { FeatureKey };
